module.exports = __webpack_public_path__ + "media/images/pic/labels/materials/waku-waku-3-a28ec13d3a2710fdf16380031622979a.jpg";